import { useEffect, useState } from 'react';
import PosLandingBrand from './PosLandingBrand';
import { LANDING_BRAND_NAME, LANDING_SECTIONS } from '../constants/posLandingConst';

/**
 * The sticky top bar, and the drawer that replaces its links on a phone.
 *
 * Gains a hairline and shadow once the page has scrolled, so it separates
 * from the content sliding under it but sits flat over the hero at rest.
 *
 * @returns {JSX.Element}
 */
function PosLandingNav() {
  const [stuck, setStuck] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /** Closes the drawer once a link in it is followed. @returns {void} */
  const closeDrawer = () => setOpen(false);

  const cta = `Try ${LANDING_BRAND_NAME} Free`;

  return (
    <header className={`nav${stuck ? ' stuck' : ''}`}>
      <div className="wrap nav-in">
        <PosLandingBrand />
        <nav className="nav-links">
          <a href={`#${LANDING_SECTIONS.work}`}>See it work</a>
          <a href={`#${LANDING_SECTIONS.pricing}`}>Pricing</a>
          <a href={`#${LANDING_SECTIONS.faq}`}>FAQs</a>
          <a href={`#${LANDING_SECTIONS.pricing}`} className="nav-cta">{cta}</a>
        </nav>
        <button
          type="button"
          className="burger"
          aria-expanded={open}
          aria-controls="kl-drawer"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((value) => !value)}
        >
          <span /><span /><span />
        </button>
      </div>
      <div className={`drawer${open ? ' open' : ''}`} id="kl-drawer">
        <div className="drawer-in">
          <a href={`#${LANDING_SECTIONS.work}`} onClick={closeDrawer}>See it work</a>
          <a href={`#${LANDING_SECTIONS.pricing}`} onClick={closeDrawer}>Pricing</a>
          <a href={`#${LANDING_SECTIONS.faq}`} onClick={closeDrawer}>FAQs</a>
          <a href={`#${LANDING_SECTIONS.pricing}`} className="btn btn-primary" onClick={closeDrawer}>{cta}</a>
        </div>
      </div>
    </header>
  );
}

export default PosLandingNav;
